<template>
	<a @click.prevent="toggleClass" href="#" class="block">
		<i class="text-2xl" :class="[isFaved ? 'fas fa-heart' : 'far fa-heart']"></i>
	</a>	
</template>

<script>
	import axios from 'axios';
	export default {
		name: 'AddFavorite',
		props:{
			fav: {
				type:String,
				required:true
			},
			action:{
				type:String,
				required:true
			},
			product_id : {
				required: true,
			}
		},
		mounted(){
			this.isFaved=this.fav
		},
		data: () => ({
			isFaved: '',
		}),
		methods:{
			toggleClass(){
				axios.post(this.action,{'product_id' : this.product_id})
				.then(response => {
					this.isFaved= !this.isFaved;
				})
			}
		}
	};
</script>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// resources/assets/js/front/components/GeneralComponents/AddFav.vue